import { render, staticRenderFns } from "./submission_detail.vue?vue&type=template&id=4a72b374&scoped=true&"
import script from "./submission_detail.vue?vue&type=script&lang=ts&"
export * from "./submission_detail.vue?vue&type=script&lang=ts&"
import style0 from "./submission_detail.vue?vue&type=style&index=0&id=4a72b374&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a72b374",
  null
  
)

export default component.exports